/* This file is autogenerated, see readme.md for instructions */
import PassThroughSvgIcon from '@bloomreach/banana-theme/icons/pass-through.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PassThroughIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PassThroughSvgIcon />
    </Icon>
  );
});

PassThroughIcon.displayName = 'PassThroughIcon';

export default PassThroughIcon;
